import * as schoolGroup from './school-group.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';
export const getschoolGroupState = createFeatureSelector<schoolGroup.SchoolGroupState>('schoolgroup');

export const SchoolGroup = createSelector(getschoolGroupState, state => state.schoolGroup);
export const Loading = createSelector(getschoolGroupState, state => state.loading);
export const Error = createSelector(getschoolGroupState, state => state.error);
